import { FC } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

interface ActionProps {
  label: string;
  onClick: () => void;
  trackingId?: string;
  disabled?: boolean;
}

interface FilterTrayActionProps {
  clearAllAction?: ActionProps;
  primaryAction?: ActionProps;
  secondaryAction?: ActionProps;
}

export const FilterTrayActions: FC<FilterTrayActionProps> = ({ clearAllAction, primaryAction, secondaryAction }) => {
  return (
    <div css={styles.container}>
      {clearAllAction && (
        <Button
          variant={'tertiary'}
          onClick={clearAllAction.onClick}
          disabled={clearAllAction.disabled}
          css={{ marginRight: 'auto' }}
          trackingId={clearAllAction.trackingId}
        >
          {clearAllAction.label}
        </Button>
      )}
      {secondaryAction && (
        <Button variant='secondary' trackingId={secondaryAction.trackingId} onClick={secondaryAction.onClick}>
          {secondaryAction.label}
        </Button>
      )}
      {primaryAction && (
        <Button variant='primary' trackingId={primaryAction.trackingId} onClick={primaryAction.onClick}>
          {primaryAction.label}
        </Button>
      )}
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    gap: ${theme.spacing(2)};
    align-items: center;
    justify-content: flex-end;
    padding: ${theme.spacing(2, 4)};
    border-top: 1px solid ${theme.colors.neutral10};
  `,
};
